import { DIReason } from "../../cubiq-model-multi-asset";
export enum DIFilterReason {
  ENTRY_CREDIT_FAIL,
  ENTRY_CREDIT_PROXIMITY_FAIL,
  MODIFY_CREDIT_FAIL,
  MODIFY_CREDIT_PROXIMITY_FAIL,
  CREDIT_REJECT,
  CREDIT_CANCEL_EXPIRY,
  FILL_CREDIT_FAIL,
  DAILY_REVAL_CREDIT_FAIL,
  PROXIMITY_REVAL_CREDIT_FAIL,
  FORCE_TO_DI,
  SOFT_CUT_OFF,
  CANCEL_DURING_SOFT_CUT_OFF,
  FIXING_RATE_REQUIREMENT,
  FILL_WITHELD,
  FILL_NOT_RECEIVED,
  PORTFOLIO_FWD_ROLL,
  PORTFOLIO_FWD_ROLL_AUTO_SAVED,
  PORTFOLIO_FWD_ROLL_ERROR,
}
export namespace DIFilterReason {
  export const getData = (reason: DIReason) => DIReason[reason];

  export function getFilterValue(reason: string) {
    switch (DIFilterReason[reason]) {
      case DIFilterReason.CREDIT_REJECT:
        return [DIReason[DIReason.CREDIT_REJECT_TIMEOUT], DIReason[DIReason.CREDIT_REJECT_FAIL]];
      case DIFilterReason.CREDIT_CANCEL_EXPIRY:
        return [
          DIReason[DIReason.CREDIT_CANCEL_FAIL],
          DIReason[DIReason.CREDIT_CANCEL_TIMEOUT],
          DIReason[DIReason.CREDIT_EXPIRY_TIMEOUT],
          DIReason[DIReason.CREDIT_EXPIRY_FAIL],
        ];
      default:
        return [DIReason[DIReason[reason]]];
    }
  }

  export function getFilterDisplayValue(reason: string) {
    switch (DIReason[reason]) {
      case DIReason.CREDIT_REJECT_TIMEOUT:
      case DIReason.CREDIT_REJECT_FAIL:
        return DIFilterReason[DIFilterReason.CREDIT_REJECT];
      case DIReason.CREDIT_CANCEL_FAIL:
      case DIReason.CREDIT_CANCEL_TIMEOUT:
      case DIReason.CREDIT_EXPIRY_TIMEOUT:
      case DIReason.CREDIT_EXPIRY_FAIL:
        return DIFilterReason[DIFilterReason.CREDIT_CANCEL_EXPIRY];
      default:
        return DIReason[DIReason[reason]];
    }
  }
}
